<template>
  <div class="glossary-row container">
    <div class="row-left">
      <strong class="strong">{{ item }}</strong>
      <span v-if="type" class="soft">{{ type }}</span>
    </div>
    <div class="row-right">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlossaryRow',

  props: {
    item: {
      type: String,
      required: true
    },
    type: {
      type: String
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/styles/variables.sass'

.glossary-row
  margin: $margin 0
  display: flex
  &:last-child
    border-bottom: none
    padding-bottom: 0

.row-left
  display: flex
  min-width: 30%
  max-width: 30%
  text-align: right
  flex-direction: column

.row-right
  padding-left: $margin
</style>
